import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Row, Col, Input, UncontrolledCollapse, Progress} from 'reactstrap';
import {ButtonGroup, Button} from 'reactstrap';
import _ from 'lodash' ;

import {convertDatetime} from '../common';


class SubmissionList extends Component
{

	constructor(props)
	{
        super(props);

		this.state = 
		{
			filter: '',
			filteredSubmissions: this.props.submissions,
			currentPage:0,
			numOfPages:0
        };
		/*TODO: Handle props.pageSize by adding default value*/

		this.observer = null;
		this.el = null;

		this.onFilterChange = this.onFilterChange.bind(this);
		this.handleLastSubmissionAnimation = this.handleLastSubmissionAnimation.bind(this);
		this.turnPageLeft = this.turnThePage.bind(this, -1);
		this.turnPageBegin= this.turnThePage.bind(this, 0);
		this.turnPageRight= this.turnThePage.bind(this, 1);
    }
	

	onFilterChange(event)
	{
		this.setState({filter:event.target.value});
		window.setTimeout(()=>{this.applyFilter()}, 0);
	}

	componentDidMount()
	{
		this.applyFilter();
	}

	componentDidUpdate(prevProps)
	{
		let areSame = true;
		if(prevProps.submissions !== this.props.submissions ||
			prevProps.submissions.length !== this.props.submissions.length)
		{
			areSame = false;
		}
		else 
		{
			let hasForce = _.has(prevProps, 'forceUpdate');	
			if(	hasForce !== _.has(this.props, 'forceUpdate') ||
				(hasForce === true && prevProps.forceUpdate!== this.props.forceUpdate))
			{
				areSame = false;
			}

		}


		if(!areSame)
		{
			window.setTimeout(()=>{this.applyFilter()}, 0);
		}
	}

	applyFilter()
	{
		let submissions = this.props.submissions;
		let pageSize = _.has(this.props, 'pageSize') ? this.props.pageSize : 10;

		if(this.state.filter.trim().length !== 0)
		{
			submissions = _.filter(submissions, (obj)=>(obj.avatar.startsWith(this.state.filter)));
		}

		if(this.props.hasOwnProperty('group') && this.props.group)
		{
			submissions  = _.groupBy(submissions, (el) => el.avatar);
			submissions = _.values(submissions);
		}

		let numOfPages = submissions.length / pageSize;
		numOfPages = Math.ceil(numOfPages);
		let currentPage = this.state.currentPage;

		if(this.state.currentPage >= numOfPages)
		{
			currentPage = 0;
		}

		this.setState(
			{
				filteredSubmissions:submissions, 
				currentPage:currentPage,
				numOfPages:numOfPages
			});
		
	}

	handleLastSubmissionAnimation(el)
	{
		if(this.observer === null)
		{
			this.observer = new MutationObserver(onAttributeChange);
		}

		if(el)
		{
			/*TODO test if this works when you add new element to end*/
			if(el !== this.el)
			{
				this.observer.disconnect();
				var ell = el.nextSibling;
				this.observer.observe(ell, {attributes:true});
			}
		}
		else
		{
			this.el = null;
			this.observer.disconnect();
		}
	}

	renderScore(props)
	{
		const color = (props.score === 100) ? 'success' : (props.score >= 50 ? 'warning' : 'info');

		return <Progress value={props.score} color={color}>{props.score}%</Progress>;

	}

	renderSubmission(props)
	{
		if(_.isNil(props.data))
		{
			return null;
		}

		const hasOther = (_.has(props, 'other') && props.other.length !== 0);
	
	
		let others = null;
		if(hasOther)
		{
			others = _.map(props.other, (el)=>
				{
	
					return (
						this.renderSubmission(
							{
								data : el,
								noId:true,
							}
						));
				});
		}
	
		var id = (hasOther && !(props.hasOwnProperty('noId') && props.noId)) ?
						('toggle'+props.data.avatar): null;
	
		var ref  = (hasOther && props.hasOwnProperty('last')) ? props.last : null;
	
		const commentIconColor = (props.data.hasReviewForLoggedProfessor && props.data.requested && !props.data.anwsered) ? 'red' : null;
		const commentIcon = (props.data.anwsered) ? 'fa-comment' : 'fa-comment-o'; 
	
		return (
			<React.Fragment>
				
				<li className = 'list-group-item submission' 
					ref={ref}
					onClick = {hasOther ? handleAnimationDropDownArrow : null}
					key={props.data.idProblemSubmission}
					style={props.style}
					>
						<Row className='align-items-center h-100'>
							<Col style = {{textAlign:'center'}}>
								<Row className='align-items-center'>
									<Col  data-noToggle={true}>
										<Link to={`/user/${props.data.avatar}`}
											  data-noToggle={true} className={'default-link'}>
											{props.data.avatar}
										</Link>
									</Col>
									<Col id={id} xs='4'>
										{props.data.name}
									</Col>
									<Col id={id} xs='2'>
										{convertDatetime(props.data.timestamp)}
									</Col>
									<Col id={id} xs = '2'>
										{this.renderScore({score:props.data.score})}
									</Col>

									{/*
										* XXX: Here we set up new event handler onClick on 
										* every render. This could affect efficiency.
										* If so extract this "buttons (Col elements)" to sub 
										* components where you will bind argument in constructor
										*/
									}

									  <Col data-noToggle={true}>
										  <span className={'fa ' + commentIcon}
												style=
													{
														{
															color:commentIconColor,
															cursor:'pointer'
														}
													}
												data-noToggle={true}
												onClick={()=> this.props.toggleCodeReviewModal(props.data)}

										  >
										</span>
									  </Col>
	

						</Row>
							</Col>
							<div id={id} style={{width:30}}>
								{
									hasOther &&
									<span className = 'fa fa-caret-down'
										  style=
											  {
											  	{
											  		transition:'transform 1s',
													coursor:'pointer'
											  	}
											  }
										>
									</span>
								}
							</div>
						</Row>
	
				</li>
				{
					hasOther &&
						<UncontrolledCollapse toggler={'#' + id} key={`c${props.data.idProblemSubmission}`}>
							{others}
						</UncontrolledCollapse>
				}
			</React.Fragment>
		);
	}

	turnThePage(value)
	{
		let pageNum = this.state.currentPage;

		if(value === 0)
		{
			pageNum = 0;
		}
		else if(value === 1 || value === -1)
		{
			pageNum = pageNum + value;
		}
		else
		{
			pageNum = value-1;
		}

		this.setState({currentPage:pageNum});
	}

	renderPageButtons()
	{
		if(this.state.numOfPages <= 1)
		{
			return null;
		}

		const toLeftDisabled= (this.state.currentPage === 0)
		const toRightDisabled = this.state.currentPage === this.state.numOfPages-1

		return (
			<Row className='mb-2 justify-content-end'>
				<Col xs='auto'>
					<ButtonGroup>
						<Button disabled={toLeftDisabled}
							onClick={this.turnPageBegin}
						>
							<span className='fa fa-angle-double-left fa-lg'></span>
						</Button>
						<Button disabled={toLeftDisabled}
							onClick={this.turnPageLeft}
						>
							<span className='fa fa-angle-left fa-lg'></span>
						</Button>

						<Row className='align-items-center'>
							<Col style={{paddingRight:'0px'}}>
								<span style={{padding:'5px'}}>
									{this.state.currentPage + 1} / {this.state.numOfPages}
								</span>
							</Col>
						</Row>

						<Button disabled={toRightDisabled}
							onClick={this.turnPageRight}
						>
							<span className='fa fa-angle-right fa-lg'></span>
						</Button>
						<Button disabled={toRightDisabled}
							onClick = {()=>this.turnThePage(this.state.numOfPages)}
						>
							<span className='fa fa-angle-double-right fa-lg'></span>
						</Button>
					</ButtonGroup>
					
				</Col>
			</Row>

		);
	}

	render()
	{
		let pageSize = _.has(this.props, 'pageSize') ? this.props.pageSize : 10;

		const hasOther = (_.has(this.props, 'group') && this.props.group);

		let offset = this.state.currentPage*pageSize;
		let submissionsToShow = 
			_.slice(this.state.filteredSubmissions, offset, offset+pageSize);

		let lastSubmission = submissionsToShow.pop();
		submissionsToShow = _.map(submissionsToShow, (el)=>
			{
				let props = {};
				if(hasOther)
				{
					props.data = _.head(el);
					props.other = _.tail(el);
				}
				else
				{
					props.data = el;
				}

				return this.renderSubmission(props);
			});

		let props = {};
		if(hasOther)
		{
			props.data = _.head(lastSubmission);
			props.other = _.tail(lastSubmission);
		}
		else
		{
			props.data = lastSubmission;
		}

		props.last = this.handleLastSubmissionAnimation;

		lastSubmission = this.renderSubmission(props);


		return (
			<React.Fragment>
				<Row className='mb-2'>
					<Col xs='2'>Filter:</Col>
					<Col>
						<Input value={this.state.filter}
							onChange = {this.onFilterChange}/>
					</Col>
				</Row>
				{this.renderPageButtons()}
				<Row>
					<Col>
						{submissionsToShow}
						{lastSubmission}
					</Col>
				</Row>
			</React.Fragment>
		);
    }
}


//==========================================Helper Components======================================


function onAttributeChange(mutationList)
{
	for(var mutation of mutationList)
	{
		if(mutation.attributeName === 'class')
		{
			if(mutation.target.className.trim() === 'collapse')
			{
				mutation.target.previousSibling.style
					.setProperty('transition', 
					'border-bottom-right-radius 0.5s,border-bottom-left-radius 0.5s');
				mutation.target.previousSibling.style
					.removeProperty('border-radius');
			}
			else
			{

				mutation.target.previousSibling.style
					.removeProperty('transition');
				mutation.target.previousSibling
					.style.setProperty('border-bottom-right-radius', 0, 'important');
				mutation.target.previousSibling
					.style.setProperty('border-bottom-left-radius', 0, 'important');
			}
		}

	}
}

function hasParentWithId(id, el)
{
	while(el !== null && el.getAttribute('id') !== id)
	{
		el = el.parentElement;
	}

	return el !== null;
}

function handleAnimationDropDownArrow(event)
{
	/*Find parent with name LI*/
	var el = event.target;
	while(el.nodeName !== 'LI')
	{
		el =  el.parentElement;
	}

	var id = el.nextSibling.getAttribute('toggler').slice(1);
	if(!hasParentWithId(id, event.target))
	{
		return ;
	}


	el = el.querySelector('span.fa.fa-caret-down');
	var state = null;

	if(el.hasAttribute('data-state'))
	{
		state = el.getAttribute('data-state');
	}
	else
	{
		state = 'off';
		el.setAttribute('data-state', state);
	}


	if(state === 'on')
	{
		el.style.transform= 'rotate(0deg)';
		state = 'off';
		el.setAttribute('data-state', state);
	}
	else
	{
		el.style.transform =  'rotate(180deg)';
		state = 'on';
		el.setAttribute('data-state', state);

	}
}


//=================================================================================================

export default SubmissionList;
